import React, { useEffect, useState } from 'react';
import { Modal, message } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { startAnneeScolaire } from './annee-scolaire.reducer';

interface ConfirmStartAnneeScolaireModalProps {
  visible: boolean;
  anneeScolaireId: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmStartAnneeScolaireModal = ({ visible, anneeScolaireId, onConfirm, onCancel }: ConfirmStartAnneeScolaireModalProps) => {
  const dispatch = useAppDispatch();

  const handleConfirmStart = () => {
    if (anneeScolaireId) {
      dispatch(startAnneeScolaire(anneeScolaireId));
      onConfirm();
    }
  };

  return (
    <Modal
      title="Confirmer le début de l'Année Scolaire"
      visible={visible}
      onOk={handleConfirmStart}
      onCancel={onCancel}
      okText="Confirmer"
      cancelText="Annuler"
    >
      <p>
        Etes-vous sûr de vouloir commencer cette Année Scolaire ? Cette action mettra son statut à ACTIF et mettra à jour les inscriptions
        associées.
      </p>
    </Modal>
  );
};

export default ConfirmStartAnneeScolaireModal;
